import TimerWorker from "flow/workers/TimerWorker";
import { ITimerWorkerFactory } from "./ITimerWorkerFactory";

const factory: ITimerWorkerFactory = {
    createTimerWorker() {
        return new TimerWorker();
    }
};

export default factory;
